<template>
  <div
    :class="[sizeClass, 'shrink-0 rounded-full overflow-hidden flex items-center justify-center font-bold text-white select-none']"
    :style="!logoSrc ? { backgroundColor: bgColor } : {}"
  >
    <img
      v-if="logoSrc"
      :src="logoSrc"
      :alt="name"
      class="w-full h-full object-contain bg-white p-1"
      @error="onError"
    />
    <span v-else :class="textClass">{{ initials }}</span>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  name:    { type: String, default: '' },
  logoUrl: { type: String, default: null },
  size:    { type: String, default: 'md' },   // sm | md | lg
});

const failed = ref(false);

const logoSrc = computed(() => (!failed.value && props.logoUrl) ? props.logoUrl : null);

const initials = computed(() => {
  const words = (props.name || '').replace(/ IPO$/i, '').trim().split(/\s+/);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return (words[0]?.[0] || '?').toUpperCase();
});

const bgColor = computed(() => {
  const colors = [
    '#2563EB','#7C3AED','#DB2777','#DC2626','#D97706',
    '#059669','#0891B2','#4F46E5','#65A30D','#EA580C',
  ];
  let hash = 0;
  for (const ch of props.name || '') hash = (hash * 31 + ch.charCodeAt(0)) & 0xffffffff;
  return colors[Math.abs(hash) % colors.length];
});

const sizeClass = computed(() => ({ sm: 'w-8 h-8', md: 'w-10 h-10', lg: 'w-14 h-14' }[props.size] ?? 'w-10 h-10'));
const textClass = computed(() => ({ sm: 'text-xs', md: 'text-sm', lg: 'text-lg' }[props.size] ?? 'text-sm'));

function onError() { failed.value = true; }
</script>
